var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PageHeading } from '../../../../components/shared';
import React from 'react';
import { DefaultLoadingComponent } from '../default-loading-component';
import { useAppSelector } from '../../../../components/app/hooks';
export var LoaderForHeaders = function (_a) {
    var props = __rest(_a, []);
    var isLoaderEnabled = useAppSelector(function (state) { return state.loadingStore.isLoaderEnabled; });
    return (React.createElement(PageHeading, __assign({}, props, { title: isLoaderEnabled ? React.createElement(DefaultLoadingComponent, { height: 40, count: 1 }) : React.createElement("span", null), icon: '' })));
};
